// extracted by mini-css-extract-plugin
export default {"container":"ProfileConsole_container__7sWKs","tabs":"ProfileConsole_tabs__z3oss","activeTab":"ProfileConsole_activeTab__5ryyB"};